// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"f68485b2","89":"b8dd7a75","393":"ab937e46","490":"b1e5580a","854":"e8e8521f"}[chunkId] + ".css";
};